import React from 'react';
import styles from './index.module.scss';
import updateExtensionDemoVideoUrl from '@cp/assets/videos/collections-update-extension-nudge.mp4';

const UpdateExtensionDemo = () => (
  <div className={styles.container}>
    <video width={1200} height={768} autoPlay controls>
      <source src={updateExtensionDemoVideoUrl} type="video/mp4" />
      Your browser does not support the video
    </video>
  </div>
);

export default UpdateExtensionDemo;
